import { ZoneValidator } from 'models';

import { zoneControlMethodsValidator } from './zone-control-methods';
import { checkCurrentLevels } from './zone-current-levels';
import { checkVoltageLevels } from './zone-voltage-levels';
import { checkZoneVoltageTypes } from './zone-voltage-types';

const controlZoneValidator: ZoneValidator['validator'] = (props) => {
    return [
        ...zoneControlMethodsValidator(props),
        ...checkVoltageLevels(props),
        ...checkCurrentLevels(props),
        ...checkZoneVoltageTypes(props),
    ];
};

export { controlZoneValidator };
